(function () {
  'use strict';

  var CDN = 'https://www.thepaintlaboratory.com/cdn/shop/files/';

  var GENERAL = [
    ["LILAC",26,["1739851932","1739851935","1739851938","1739851941","1739851944","1739851947","1739851951","1739851954"]],
    ["IRIS",21,["1739851680","1739851683","1739851685","1739851688","1739851691","1739851694","1739851698","1739851701"]],
    ["MIST",33,["1739852942","1739852945","1739852948","1739852951","1739852955","1739852959","1739852962","1739852966"]],
    ["AUBEGINE",6,["1739845082","1739845085","1739845089","1739845093","1739845096","1739845100","1739845106","1739845109"]],
    ["GRANITE",22,["1739851726","1739851729","1739851732","1739851735","1739851738","1739851743","1739851747","1739851750"]],
    ["FOG",18,["1739851470","1739851473","1739851476","1739851479","1739851483","1739851487","1739851490","1739851494"]],
    ["LICHEN",25,["1739851884","1739851887","1739851890","1739851894","1739851897","1739851901","1739851904","1739851908"]],
    ["MARBLE",31,["1739852641","1739852645","1739852648","1739852652","1739852655","1739852659","1739852662","1739852666"]],
    ["ASH",3,["1739842854","1739842858","1739842862","1739842866","1739842874","1739842953","1739842877","1739842882"]],
    ["SIENNA",44,["1739853781","1739853784","1739853788","1739853792","1739853797","1739853801","1739853806","1739853810"]],
    ["FOSSIL",19,["1739851533","1739851536","1739851539","1739851542","1739851546","1739851548","1739851553","1739851556"]],
    ["TEAK",48,["1739853999","1739854001","1739854005","1739854007","1739854011","1739854014","1739854017","1739854021"]],
    ["MAHAGONY",29,["1739852489","1739852492","1739852495","1739852550","1739852554","1739852562","1739852568","1739852577"]],
    ["MESA",54,["1739929569","1739929584","1739929591","1739929599","1739929606","1739929622","1739929628","1739929634"]],
    ["CEDAR",10,["1739846336","1739846339","1739846342","1739846345","1739846349","1739846352","1739846355","1739846358"]],
    ["CHOCOLATE",9,["1739845036","1739845041","1739845044","1739845046","1739845050","1739845053","1739845057","1739845061"]],
    ["WALNUT",53,["1739854308","1739854311","1739854313","1739854316","1739854320","1739854328","1739854352","1739854332"]],
    ["DESERT",16,["1739850963","1739850966","1739850969","1739850973","1739850976","1739850981","1739850984","1739850988"]],
    ["PIETRA",38,["1739853158","1739853161","1739853164","1739853168","1739853171","1739853174","1739853178","1739853182"]],
    ["UMBER",52,["1739854268","1739854272","1739854274","1739854277","1739854282","1739854285","1739854289","1739854293"]],
    ["TRUFFLE",51,["1739854220","1739854224","1739854232","1739854235","1739854239","1739854244","1739854248","1739854251"]],
    ["JAVA",23,["1739851770","1739851773","1739851776","1739851779","1739851783","1739851786","1739851789","1739851793"]],
    ["RUSSET",39,["1739853195","1739853197","1739853201","1739853205","1739853208","1739853211","1739853215","1739853220"]],
    ["MUSHROOM",35,["1739853023","1739853025","1739853028","1739853032","1739853035","1739853038","1739853042","1739853049"]],
    ["LINEN",28,["1739852452","1739852455","1739852458","1739852462","1739852465","1739852469","1739852472","1739852476"]],
    ["CANYON",40,["1739853236","1739853240","1739853243","1739853246","1739853251","1739853253","1739853256","1739853260"]],
    ["BRICK",7,["1739845126","1739845128","1739845132","1739845135","1739845142","1739845145","1739845147","1739845150"]],
    ["MAPLE",30,["1739852603","1739852606","1739852609","1739852612","1739852615","1739852618","1739852622","1739852626"]],
    ["BEECH",15,["1739851019","1739851021","1739851024","1739851028","1739851031","1739851036","1739851039","1739851044"]],
    ["CHAMOIS",13,["1739846566","1739846568","1739846571","1739846574","1739846579","1739846582","1739846586","1739846589"]],
    ["SADDLE",41,["1739853679","1739853682","1739853685","1739853689","1739853691","1739853694","1739853697","1739853700"]],
    ["KHAKI",24,["1739851807","1739851814","1739851816","1739851820","1739851822","1739851825","1739851829","1739851832"]],
    ["SAND",42,["1739853714","1739853717","1739853719","1739853723","1739853726","1739853729","1739853732","1739853735"]],
    ["HEMP",20,["1739851568","1739851571","1739851574","1739851578","1739851586","1739851657","1739851590","1739851593"]],
    ["OCHRE",37,["1739853121","1739853124","1739853127","1739853130","1739853134","1739853138","1739853142","1739853146"]],
    ["TAUPE",47,["1739853947","1739853950","1739853952","1739853956","1739853960","1739853964","1739853967","1739853971"]],
    ["SAGUARO",8,["1739845184","1739845188","1739845232","1739845193","1739845195","1739845199","1739845202","1739845205"]],
    ["DRIFTWOOD",17,["1739851087","1739851090","1739851093","1739851097","1739851100","1739851105","1739851108","1739851111"]],
    ["TOBACCO",50,["1739854160","1739854163","1739854166","1739854172","1739854176","1739854179","1739854188","1739854210"]],
    ["LMESTONE",27,["1739852419","1739852421","1739852424","1739852428","1739852431","1739852434","1739852437","1739852441"]],
    ["MOSS",34,["1739852981","1739852984","1739852987","1739852991","1739852994","1739852997","1739853000","1739853004"]],
    ["CASCADE",9,["1739846293","1739846297","1739846301","1739846305","1739846312","1739846323","1739846318","1739846315"]],
    ["CEMENT",12,["1739846427","1739846430","1739846432","1739846440","9:1739845050","1739846442","1739846450","1739846454"]],
    ["CELADON",11,["1739846371","1739846374","1739846376","1739846380","1739846383","1739846390","1739846417","1739846392"]],
    ["SLATE",45,["1739853823","1739853826","1739853829","1739853832","1739853836","1739853839","1739853842","1739853846"]],
    ["TEAL",49,["1739854046","1739854049","1739854052","1739854060","1739854150","1739854062","1739854066","1739854069"]],
    ["OCEAN",36,["1739853086","1739853089","1739853092","1739853095","1739853098","1739853102","1739853106","1739853110"]],
    ["COASTAL",46,["1739853860","1739853863","1739853866","1739853873","1739853933","1739853875","1739853879","1739853883"]],
    ["SEA",43,["1739853747","1739853750","1739853753","1739853756","1739853759","1739853762","1739853765","1739853769"]],
    ["ASPHALT",5,["1739843240","1739843243","1739843247","1739843250","1739843254","1739843259","1739843262","1739843271"]]
  ];

  var NEUTRAL = [
    ["MERCURY",23,"1739942030762","1739942178"],
    ["LEAD",22,"1739942029312","1739942173"],
    ["TAR",24,"1739942196354","1739942201"],
    ["CARBON",20,"1739942027323","1739942154"],
    ["MINK",6,"1739832616894","1739848317"],
    ["GRAPHITE",4,"1739832616892","1739848309"],
    ["BLACKBERRY",1,"1739832616889","1739848298"],
    ["STORMY SKY",9,"1739832616897","1739848332"],
    ["BORON",19,"1739942024631","1739942150"],
    ["RAISIN",7,"1739832616895","1739848321"],
    ["CHARCOAL",3,"1739832616891","1739848305"],
    ["BLACK FERN",2,"1739832616890","1739848301"],
    ["CROW",21,"1739942028225","1739942168"],
    ["SHADOW",8,"1739832616896","1739848325"],
    ["MIDNIGHT",5,"1739832616893","1739848314"],
    ["SHADE WHITE",17,"1739832616905","1739848393"],
    ["PURE WHITE",16,"1739832616904","1739848387"],
    ["LAB WHITE",15,"1739832616903","1739848383"],
    ["PENITENTE",30,"1739942372062","1739942439"],
    ["CHALK WHITE",11,"1739832616899","1739848348"],
    ["WHITE LIGHT",18,"1739832616906","1739848397"],
    ["CREAMY WHITE",12,"1739832616900","1739848353"],
    ["FRENCH VANILLA",13,"1739832616901","1739848363"],
    ["FLEECE",29,"1739942370328","1739942424"],
    ["COTTON",28,"1739942369400","1739942417"],
    ["SALT",27,"1739942368506","1739942401"],
    ["SQUALL",26,"1739942366748","1739942393"],
    ["BONE WHITE",10,"1739832616898","1739848344"],
    ["GLACIER WHITE",14,"1739832616902","1739848370"],
    ["AVALANCHE",25,"1739942364367","1739942406"]
  ];

  var VIVID = [
    ["MOUNTAIN RAY",33,"1739831638785","1739848725"],
    ["LAVENDER",29,"1739831638781","1739848711"],
    ["MORADO",79,"1739991982614","1739992306"],
    ["VIOLET",47,"1739831638799","1739848817"],
    ["BLUEPRINT",3,"1739831638755","1739848561"],
    ["PERIWINKLE",35,"1739831638787","1739848736"],
    ["MARIANAS",45,"1739831638778","1739927091"],
    ["FJORD",72,"1739991982607","1739992262"],
    ["PEACOCK",50,"1739831638802","1739927494"],
    ["DELFT",74,"1739991982609","1739992268"],
    ["INDIGO",24,"1739831638776","1739848658"],
    ["COBALT",12,"1739831638764","1739848605"],
    ["CADET",78,"1739991982613","1739994003"],
    ["ELEANOR",71,"1739991982606","1739994018"],
    ["CRETE",13,"1739831638765","1739848609"],
    ["CERULEAN",9,"1739831638761","1739848596"],
    ["WISTERIA",80,"1739991982615","1739992344"],
    ["FRIDGID",73,"1739991982608","1739994008"],
    ["HAINT BLUE",77,"1739991982612","1739993999"],
    ["SKYLINE",76,"1739991982611","1739993996"],
    ["CAROLINA",32,"1739831638784","1739833659"],
    ["MEDITERRANEAN",75,"1739991982610","1739992290"],
    ["CARIBBEAN",7,"1739831638759","1739848588"],
    ["LAGOON",69,"1739991888418","1739993990"],
    ["TOPAZ",68,"1739991888417","1739994055"],
    ["BALI",2,"1739831638754","1739848556"],
    ["TURQUOISE",46,"1739831638798","1739848810"],
    ["CULEBRA",14,"1739831638766","1739848614"],
    ["SPRUCE",70,"1739991982605","1739994080"],
    ["SALISH",48,"1739831638756","1739927276"],
    ["APITITE",44,"1739831638777","1739927007"],
    ["ROBINS EGG",67,"1739991888416","1739993973"],
    ["SPROUT",64,"1739991888412","1739993966"],
    ["PISTACHIO",66,"1739991888415","1739992170"],
    ["KENTUCKY",28,"1739831638780","1739848707"],
    ["SWEET PEA",65,"1739991888414","1739992165"],
    ["FOREST",29,"1739831638769","1739994678"],
    ["CLOVER",11,"1739831638763","1739848602"],
    ["GRASS",20,"1739831638772","1739848641"],
    ["LETTUCE",30,"1739831638782","1739848714"],
    ["LIME",31,"1739831638783","1739848717"],
    ["SPRING",63,"1739991888411","1739993963"],
    ["CHAMOMILE",62,"1739991888410","1739994043"],
    ["FERN",15,"1739831638767","1739848620"],
    ["ALOE",65,"1739991888413","1739993969"],
    ["OLIVE",34,"1739831638786","1739848730"],
    ["AVOCADO",1,"1739831638753","1739848552"],
    ["GREEN TEA",21,"1739831638773","1739848645"],
    ["CELERY",8,"1739831638760","1739848591"],
    ["SULFUR",58,"1739991839884","1739994230"],
    ["PRIMROSE",57,"1739991839883","1739993924"],
    ["MEDALION",59,"1739991888407","1739993884"],
    ["CITRUS",10,"1739831638762","1739848598"],
    ["WHEAT",49,"1739831638801","1739848824"],
    ["SUNSHINE",43,"1739831638795","1739848779"],
    ["ANTELOPE",60,"1739991888408","1739993947"],
    ["GRAIN",19,"1739831638771","1739848638"],
    ["CURRY",61,"1739991888409","1739993951"],
    ["HONEY",23,"1739831638775","1739848654"],
    ["CLAY",46,"1739831638779","1739927225"],
    ["POTASSIUM",49,"1739831638797","1739927294"],
    ["PERSIMMON",36,"1739831638788","1739848740"],
    ["CARAMEL",6,"1739831638758","1739848584"],
    ["PENNYLOAFER",54,"1739991839881","1739992123"],
    ["SABLE",47,"1739831638796","1739927253"],
    ["PUMPKIN",38,"1739831638790","1739848750"],
    ["FLAMINGO",16,"1739831638768","1739848624"],
    ["SUMAC",56,"1739991839882","1739993935"],
    ["WATERMELON",48,"1739831638800","1739848820"],
    ["STRAWBERRY",42,"1739831638794","1739848772"],
    ["PRADA RED",37,"1739831638789","1739848746"],
    ["RED FLYER",40,"1739831638792","1739848762"],
    ["POPPY",55,"1739991839880","1739993938"],
    ["ROSE",41,"1739831638793","1739848766"],
    ["PHEASANT",52,"1739991839879","1739992100"],
    ["CABERNET",5,"1739831638757","1739848580"],
    ["FUSCHIA",18,"1739831638770","1739848636"],
    ["DAHLIA",54,"1739991839878","1739993943"],
    ["RASBERRY",39,"1739831638791","1739848754"],
    ["HEATHER",22,"1739831638774","1739848649"]
  ];

  var METALS = [
    ["Graphite","Graphite.png?v=1775754864"],
    ["Mercury","Mercury.png?v=1775754864"],
    ["Blued Steel","Blued_Steel.png?v=1775754864"],
    ["Steel","Steel.png?v=1775754864"],
    ["Aluminum","Aluminum.png?v=1775754864"],
    ["Silver","Silver.png?v=1775754864"],
    ["Quartz","Quartz.png?v=1775754864"],
    ["Champagne","Champagne.png?v=1775754864"],
    ["Titanium","Titanium.png?v=1775754864"],
    ["Smoke","Smoke.png?v=1775754864"],
    ["Cast Bronze","Cast_Bronze.png?v=1775754864"],
    ["Figurehead","Figurehead.png?v=1775754864"],
    ["Farthing","Farthing.png?v=1775754864"],
    ["Pyrite","Pyrite.png?v=1775754864"],
    ["Jade","Jade.png?v=1775754864"],
    ["Green Gold","Green_Gold.png?v=1775754864"],
    ["Rose Gold","Rose_Gold.png?v=1775754864"],
    ["Polished Brass","Polished_Brass.png?v=1775754864"],
    ["Ballroom Gold","Ballroom_Gold.png?v=1775754864"],
    ["Brushed Gold","Brushed_Gold.png?v=1775754864"],
    ["Bronze","Bronze.png?v=1775754864"],
    ["Copper","Copper.png?v=1775754864"],
    ["Fire Opal","Fire_Opal.png?v=1775754864"],
    ["Ruby","Ruby.png?v=1775754864"]
  ];

  var PATINA = [
    ["Verdigris","Verdigris_Copper.jpg?v=1773353101"],
    ["Pewter Black","Pewter_Black_Patina_Finish.jpg?v=1773353101"],
    ["Blue Oxide","Blue_Oxide.jpg?v=1773353101"],
    ["Dark Steel Blackened","Dark_Steel_Blackened_Patina_Finish.jpg?v=1773353101"],
    ["Dark Steel Rust","Dark_Steel_Rust_Patina_Finish.jpg?v=1773353101"],
    ["Light Steel Blackened","Light_Steel_Blackened_Patina_Finish.jpg?v=1773353101"],
    ["Light Steel Rust","Light_Steel_Rust_Patina_Finish.jpg?v=1773353101"]
  ];

  function fileUrl(file) {
    var joiner = file.indexOf('?') === -1 ? '?' : '&';
    return CDN + file + joiner + 'width=96';
  }

  function generalFile(defaultId, value, part) {
    var id = defaultId;
    var suffix = part;

    if (String(part).indexOf(':') !== -1) {
      var bits = String(part).split(':');
      id = bits[0];
      suffix = bits[1];
    }

    return 'image-swatches-' + id + '_' + value + '_' +
      String(1739842650275 + value) + '-' + suffix + '.jpg';
  }

  function simpleFile(group, row) {
    return 'image-swatches-' + group + '_' + row[1] + '_' +
      row[2] + '-' + row[3] + '.jpg';
  }

  var general = [];

  GENERAL.forEach(function (row) {
    var family = row[0];
    var id = row[1];
    var parts = row[2];

    parts.forEach(function (part, index) {
      var value = index + 1;

      general.push({
        name: family + ' ' + value,
        family: family,
        value: value,
        collection: 'general',
        color: '',
        image: fileUrl(generalFile(id, value, part))
      });
    });
  });

  function expandSwatches(rows, group, collection) {
    return rows.map(function (row) {
      return {
        name: row[0],
        collection: collection,
        color: '',
        image: fileUrl(simpleFile(group, row))
      };
    });
  }

  function expandFiles(rows, collection) {
    return rows.map(function (row) {
      return {
        name: row[0],
        collection: collection,
        color: '',
        image: fileUrl(row[1])
      };
    });
  }

  window.TPL_COLOR_DATA = {
    extractedAt: "2026-08-31T04:41:34.349Z",
    source: "https://www.thepaintlaboratory.com/products/interior-paint",
    general: general,
    neutral: expandSwatches(NEUTRAL, 2, 'neutral'),
    vivid: expandSwatches(VIVID, 1, 'vivid'),
    metals: expandFiles(METALS, 'metals'),
    patina: expandFiles(PATINA, 'patina')
  };
})();